import Vue from 'vue';
import App, { router, store } from '@/App.vue';
import moment from 'moment';
import 'moment/min/locales';
import axios from 'axios';

//#region Gestion de l'internationalisation
import VueI18n, { DateTimeFormat, DateTimeFormatOptions, I18nOptions } from 'vue-i18n' // translation support
/** Format de nombre */
import numberFormats from "@/locales/numberFormats.json";

/** Format de date */
import dateTimeFormats from "@/locales/dateTimeFormats.json";

/** Traductions */
import translation from "@/locales/translation.json";

/** Signature PDF */
import VueSignaturePad from 'vue-signature-pad';

/** Variables d'environnements */
import { DCX_SESSION_EXPIRATION_DELAY } from './App.settings';

/** Médiateur de store VueX */
import { StoreMediator } from '@/mediators/StoreMediator';

export const i18n = new VueI18n({
    locale: 'fr-FR', 	 		// default language
    fallbackRoot: true,
    /** 
     * Défini un fallback par défaut si 'fr' ou 'en'
     * @description Vue-I18n défini un fallback par défaut pour 'fr-FR' -> 'fr' mais pas 'fr' -> 'fr'. Cette option permet de gérer ce cas.
     * @description Mozilla Firefox renvoi 'fr' tandis que Google Chrome renvoi 'fr-FR'
     * @see https://kazupon.github.io/vue-i18n/guide/fallback.html#explicit-fallback-with-one-locale
     */
    fallbackLocale: {
        'fr': ['fr-FR'],
        'en': ['en-GB']
      },
    sync: true,
    messages: Object.assign(translation),
    numberFormats: numberFormats as VueI18n.NumberFormats,
    dateTimeFormats: dateTimeFormats as VueI18n.DateTimeFormats
    // ,sharedMessages: Object.assign(featuresLocales)
});

moment.locale(i18n.locale);
//#endregion Gestion de l'internationalisation

Vue.config.productionTip = true;

// On force l'activation des outils de développement
// Vue.config.devtools = true;

Vue.use(VueSignaturePad);
Vue.use(VueI18n);

const mainVue = new Vue({
    i18n,
    render: h => h(App)
}).$mount('#app');


/** Intercepte les resquêtes axios et effectue un pré-traitement dessus.  */
axios.interceptors.request.use(async config => {
    /** Classe employé pour annuler la requete */
    const controller = new AbortController();

    /** Si l'axios tente un logOut on considère qu'il n'y a pas de soucis */
    if(config.url.endsWith('connexion/logout'))
        return config;

    /** Récupère les informations du token */
    const token = mainVue.$cookies.get('access_token');
    const cookieTokenTimestamp = mainVue.$cookies.get('access_token_timestamp');
    
    /** Converti le timestamp récupéré en cookie vers Numeric */
    let tokenTimestamp = 0;
    if(cookieTokenTimestamp){
        tokenTimestamp = Number.parseInt(cookieTokenTimestamp.toString())
        if(isNaN(tokenTimestamp))
            tokenTimestamp = 0;
    }
  
    /** Regarde si l'on est dans le cadre d'une session */
    if(token){
        if(tokenTimestamp != 0){
            const timestamp = Date.now();
            /** Si supérieur à DCX_SESSION_EXPIRATION_DELAY */
            if((timestamp - tokenTimestamp) > DCX_SESSION_EXPIRATION_DELAY ) {
                mainVue.$cookies.set('access_token_status','expire');
                await router.push({ name: 'SignOut' }).catch((e) => e);;
                controller.abort();
            }
            else{
                mainVue.$cookies.set('access_token_timestamp', timestamp)
            }
        }else {
            mainVue.$cookies.set('access_token_status','expire');
            await router.push({ name: 'SignOut' }).catch((e) => e);;
            controller.abort();
        }
    }
    config.signal = controller.signal;
    return config;
});
/** Intercepte les réponses axios et effectue un pré-traitement dessus. */
axios.interceptors.response.use(
  response => {
    mainVue.$cookies.set('access_token_timestamp', Date.now())
    return response
  },
  error => {
    if(error.code === 'ERR_BAD_RESPONSE' && error.response.data && error.response.data.ExceptionMessage && error.response.data.ExceptionMessage.startsWith("401 : Token invalid -> token received :")){
        mainVue.$cookies.set('access_token_status','expire');
        router.push({ name: 'SignOut' }).catch((e) => e);;
    }
    /** Fait sauté l'erreur d'annulation. Inutile de lever une érreur ERR_CANCELED car prévu par l'application */
    if (error.code === 'ERR_CANCELED') {
      return Promise.resolve(null); // ← retourne null au lieu de lever une erreur
    }else{
        mainVue.$cookies.set('access_token_timestamp', Date.now())
    }
    return Promise.reject(error);
  }
);

// Vue.use(VueI18n);

/** Initialisation du StoreMediator */
StoreMediator.GetInstance().Init(store);